import { Grid, Box, Button } from '@mui/material';

const FormActions = ({ resetForm }) => {
  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        justifyContent="space-between"
        mt={3}
        flexDirection={{ xs: 'column-reverse', sm: 'row' }}
        gap={{ xs: 2, sm: 0 }}
      >
        <Button
          variant="outlined"
          sx={{
            borderColor: "rgba(255,255,255,0.4)",
            color: "#fff",
            width: { xs: '100%', sm: 'auto' },
            "&:hover": {
              borderColor: "#fff",
              backgroundColor: "rgba(255,255,255,0.08)",
            },
          }}
          onClick={resetForm}
        >
          Clear
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: "#fff",
            color: "#1a1a2e",
            fontWeight: 600,
            width: { xs: '100%', sm: 'auto' },
            "&:hover": { backgroundColor: "#e0e0e0" },
          }}
        >
          Submit
        </Button>
      </Box>
    </Grid>
  );
};

export default FormActions;
